import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

import MainMenu from '../../menus/main/'

class Home extends Component {
    constructor( ) {
        super()
        this.state = {
            redirect: false,
            showTodosList: false,
        }
    }

    componentDidMount() {
        if ( localStorage.getItem( 'api_token' ) ) {
            this.setState({ showTodosList: true })
        } else {
            this.setState({ redirect: true })
        }
    }

    render () {
        if ( this.state.redirect ) {
            return ( <Redirect to="/login" />)
        }
        if ( this.state.showTodosList ) {
            return ( <Redirect to="/todos" />)
        }
        return (
            <>
                <MainMenu />
            </>
        )
    }
}

export default Home
